import React from 'react'

import BugEditor from '../components/bug-report/editor'

class BugEditorPage extends React.Component{

	render(){
		return (
			<div style={{ margin: 16 }}>
				<BugEditor />
			</div>
		)
	}

}

export default BugEditorPage;


// WEBPACK FOOTER //
// ./src/containers/bug-editor-page.js